import React from 'react';

export default function PatientTooltip() {
    return [
        <div>First Name; Last Name; Last Name + First Name; First Name + Last Name; DOB; DOB(MM.DD)</div>
    ];
}
